import { Send } from '@mint-lib/icons';
import { cn } from '@mint-lib/tw-utils';

import { Button } from '../../lib/button.jsx';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

const ChatSend = ({ onClick, disabled }: Props) => {
  return (
    <div
      className={cn(
        'inline-block rounded-[16px] bg-linear-to-bl from-ai-lightCyan to-ai-lightGreen p-0.5',
        disabled &&
          'bg-linear-to-tr from-text-disabled to-text-disabled text-text-disabled',
      )}
    >
      <Button
        aria-label="Send"
        onClick={onClick}
        disabled={disabled}
        className={cn(
          'size-12 rounded-[14px]',
          'bg-linear-to-tr from-ai-lightCyan to-ai-lightGreen',
          'disabled:bg-linear-to-tr disabled:from-text-disabled disabled:to-text-disabled disabled:text-text-disabled',
          'focus-visible:outline-border-focus',
          'hover:bg-linear-to-tr hover:from-ai-hoverCyan hover:to-ai-hoverGreen',
          'active:bg-linear-to-tr active:from-ai-activeCyan active:to-ai-activeGreen',
        )}
      >
        <Send className="size-5 fill-primary-contrastText" />
      </Button>
    </div>
  );
};

export default ChatSend;
